// =======================
// == Animations/CTA.js ==
// =======================
/*
  All of the animations for cta.js
*/

import Animator from './animator';

const animator = new Animator();

const animate = () =>
  animator.call('#topCTA', {
    opacity: [
      animator.partials.emptyStart,
      { delay: 0, value: 1, duration: 600 },
    ],
    easing: 'easeInQuad',
  });

export default animate;
